import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class InvoiceTypeValueObject  {
    _originalTypeClassName = "zERP.BO.InvoiceTypeValueObject";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
InvoiceTypeValueObject.translate = translateService;
}
this.IncomeConfiguration = new Domain.InvoiceTransactionConfiguration();
this.ExpensesConfiguration = new Domain.InvoiceTransactionConfiguration();
this.AccountingConfiguration = new Domain.InvoiceTransactionConfiguration();
this.Id = null;
this.Name = null;
this.Description = null;
this.Code = null;
this.CodeStr = null;
this.Expenses = false;
this.MirroredInvoices = false;
this.SkipMyDataSync = false;
this.AllowEmptyInvoiceLines = false;
this.AlreadyExistingInvoiceValidationType = null;
this.ExcludedFromSettlementPaymentOrders = false;
this.IsIssuedByUs = false;
this.Abbreviation = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Name:any;
Description:any;
Code:any;
CodeStr:any;
Expenses:any;
MirroredInvoices:any;
SkipMyDataSync:any;
AllowEmptyInvoiceLines:any;
AlreadyExistingInvoiceValidationType:any;
ExcludedFromSettlementPaymentOrders:any;
IsIssuedByUs:any;
Abbreviation:any;
IncomeConfiguration:any;
ExpensesConfiguration:any;
AccountingConfiguration:any;
DefaultPaymentMethod:any;
static setIncomeConfiguration = ($this, value) => {
var oldValue = $this.IncomeConfiguration;
$this.IncomeConfiguration = value;
if (value != null) {
}
}
static setExpensesConfiguration = ($this, value) => {
var oldValue = $this.ExpensesConfiguration;
$this.ExpensesConfiguration = value;
if (value != null) {
}
}
static setAccountingConfiguration = ($this, value) => {
var oldValue = $this.AccountingConfiguration;
$this.AccountingConfiguration = value;
if (value != null) {
}
}
static setDefaultPaymentMethod = ($this, value) => {
var oldValue = $this.DefaultPaymentMethod;
$this.DefaultPaymentMethod = value;
if (value != null) {
}
}

static CodeToDescription($this: any): any{return Domain.InvoiceTypeValueObject.InvoiceTypeToString($this?.Code);
}
static GetCodeStr($this: any): any{return $this?.Code?.toString();
}
static GetEnums(): any{let invoiceTypes = [];
invoiceTypes?.add(Domain.InvoiceType.Item11);
invoiceTypes?.add(Domain.InvoiceType.Item12);
invoiceTypes?.add(Domain.InvoiceType.Item13);
invoiceTypes?.add(Domain.InvoiceType.Item14);
invoiceTypes?.add(Domain.InvoiceType.Item15);
invoiceTypes?.add(Domain.InvoiceType.Item16);
invoiceTypes?.add(Domain.InvoiceType.Item21);
invoiceTypes?.add(Domain.InvoiceType.Item22);
invoiceTypes?.add(Domain.InvoiceType.Item23);
invoiceTypes?.add(Domain.InvoiceType.Item24);
invoiceTypes?.add(Domain.InvoiceType.Item31);
invoiceTypes?.add(Domain.InvoiceType.Item32);
invoiceTypes?.add(Domain.InvoiceType.Item4);
invoiceTypes?.add(Domain.InvoiceType.Item51);
invoiceTypes?.add(Domain.InvoiceType.Item52);
invoiceTypes?.add(Domain.InvoiceType.Item61);
invoiceTypes?.add(Domain.InvoiceType.Item62);
invoiceTypes?.add(Domain.InvoiceType.Item71);
invoiceTypes?.add(Domain.InvoiceType.Item81);
invoiceTypes?.add(Domain.InvoiceType.Item82);
invoiceTypes?.add(Domain.InvoiceType.Item84);
invoiceTypes?.add(Domain.InvoiceType.Item85);
invoiceTypes?.add(Domain.InvoiceType.Item86);
invoiceTypes?.add(Domain.InvoiceType.Item93);
invoiceTypes?.add(Domain.InvoiceType.Item111);
invoiceTypes?.add(Domain.InvoiceType.Item112);
invoiceTypes?.add(Domain.InvoiceType.Item113);
invoiceTypes?.add(Domain.InvoiceType.Item114);
invoiceTypes?.add(Domain.InvoiceType.Item115);
invoiceTypes?.add(Domain.InvoiceType.Item121);
invoiceTypes?.add(Domain.InvoiceType.Item131);
invoiceTypes?.add(Domain.InvoiceType.Item132);
invoiceTypes?.add(Domain.InvoiceType.Item133);
invoiceTypes?.add(Domain.InvoiceType.Item134);
invoiceTypes?.add(Domain.InvoiceType.Item1330);
invoiceTypes?.add(Domain.InvoiceType.Item1331);
invoiceTypes?.add(Domain.InvoiceType.Item141);
invoiceTypes?.add(Domain.InvoiceType.Item142);
invoiceTypes?.add(Domain.InvoiceType.Item143);
invoiceTypes?.add(Domain.InvoiceType.Item144);
invoiceTypes?.add(Domain.InvoiceType.Item145);
invoiceTypes?.add(Domain.InvoiceType.Item1430);
invoiceTypes?.add(Domain.InvoiceType.Item1431);
invoiceTypes?.add(Domain.InvoiceType.Item151);
invoiceTypes?.add(Domain.InvoiceType.Item161);
invoiceTypes?.add(Domain.InvoiceType.Item171);
invoiceTypes?.add(Domain.InvoiceType.Item172);
invoiceTypes?.add(Domain.InvoiceType.Item173);
invoiceTypes?.add(Domain.InvoiceType.Item174);
invoiceTypes?.add(Domain.InvoiceType.Item175);
invoiceTypes?.add(Domain.InvoiceType.Item176);
return invoiceTypes;
}
static InvoiceTypeToDecimal(invoiceType: any): any{switch (invoiceType) {case Domain.InvoiceType.Item11:
{
return 1.1;}
case Domain.InvoiceType.Item12:
{
return 1.2;}
case Domain.InvoiceType.Item13:
{
return 1.3;}
case Domain.InvoiceType.Item14:
{
return 1.4;}
case Domain.InvoiceType.Item15:
{
return 1.5;}
case Domain.InvoiceType.Item16:
{
return 1.6;}
case Domain.InvoiceType.Item21:
{
return 2.1;}
case Domain.InvoiceType.Item22:
{
return 2.2;}
case Domain.InvoiceType.Item23:
{
return 2.3;}
case Domain.InvoiceType.Item24:
{
return 2.4;}
case Domain.InvoiceType.Item31:
{
return 3.1;}
case Domain.InvoiceType.Item32:
{
return 3.2;}
case Domain.InvoiceType.Item51:
{
return 5.1;}
case Domain.InvoiceType.Item52:
{
return 5.2;}
case Domain.InvoiceType.Item61:
{
return 6.1;}
case Domain.InvoiceType.Item62:
{
return 6.2;}
case Domain.InvoiceType.Item71:
{
return 7.1;}
case Domain.InvoiceType.Item81:
{
return 8.1;}
case Domain.InvoiceType.Item82:
{
return 8.2;}
case Domain.InvoiceType.Item84:
{
return 8.4;}
case Domain.InvoiceType.Item85:
{
return 8.5;}
case Domain.InvoiceType.Item86:
{
return 8.6;}
case Domain.InvoiceType.Item93:
{
return 9.3;}
case Domain.InvoiceType.Item111:
{
return 11.1;}
case Domain.InvoiceType.Item112:
{
return 11.2;}
case Domain.InvoiceType.Item113:
{
return 11.3;}
case Domain.InvoiceType.Item114:
{
return 11.4;}
case Domain.InvoiceType.Item115:
{
return 11.5;}
case Domain.InvoiceType.Item121:
{
return 12.1;}
case Domain.InvoiceType.Item131:
{
return 13.1;}
case Domain.InvoiceType.Item132:
{
return 13.2;}
case Domain.InvoiceType.Item133:
{
return 13.3;}
case Domain.InvoiceType.Item134:
{
return 13.4;}
case Domain.InvoiceType.Item1330:
{
return 13.30;}
case Domain.InvoiceType.Item1331:
{
return 13.31;}
case Domain.InvoiceType.Item141:
{
return 14.1;}
case Domain.InvoiceType.Item142:
{
return 14.2;}
case Domain.InvoiceType.Item143:
{
return 14.3;}
case Domain.InvoiceType.Item144:
{
return 14.4;}
case Domain.InvoiceType.Item145:
{
return 14.5;}
case Domain.InvoiceType.Item1430:
{
return 14.30;}
case Domain.InvoiceType.Item1431:
{
return 14.31;}
case Domain.InvoiceType.Item151:
{
return 15.1;}
case Domain.InvoiceType.Item161:
{
return 16.1;}
case Domain.InvoiceType.Item171:
{
return 17.1;}
case Domain.InvoiceType.Item172:
{
return 17.2;}
case Domain.InvoiceType.Item173:
{
return 17.3;}
case Domain.InvoiceType.Item174:
{
return 17.4;}
case Domain.InvoiceType.Item175:
{
return 17.5;}
case Domain.InvoiceType.Item176:
{
return 17.6;}
default:
{
return 0;}
}
return 0;
}
static InvoiceTypeToString(invoiceType: any): any{switch (invoiceType) {case Domain.InvoiceType.Item11:
{
return "1.1 Τιμολόγιο Πώλησης";}
case Domain.InvoiceType.Item12:
{
return "1.2 Τιμολόγιο Πώλησης / Ενδοκοινοτικές Παραδόσεις";}
case Domain.InvoiceType.Item13:
{
return "1.3 Τιμολόγιο Πώλησης / Παραδόσεις Τρίτων Χωρών";}
case Domain.InvoiceType.Item14:
{
return "1.4 Τιμολόγιο Πώλησης / Πώληση για Λογαριασμό Τρίτων";}
case Domain.InvoiceType.Item15:
{
return "1.5 Τιμολόγιο Πώλησης / Εκκαθάριση Πωλήσεων Τρίτων - Αμοιβή από Πωλήσεις Τρίτων";}
case Domain.InvoiceType.Item16:
{
return "1.6 Τιμολόγιο Πώλησης / Συμπληρωματικό Παραστατικό";}
case Domain.InvoiceType.Item21:
{
return "2.1 Τιμολόγιο Παροχής";}
case Domain.InvoiceType.Item22:
{
return "2.2 Τιμολόγιο Παροχής / Ενδοκοινοτική Παροχή Υπηρεσιών";}
case Domain.InvoiceType.Item23:
{
return "2.3 Τιμολόγιο Παροχής / Παροχή Υπηρεσιών σε λήπτη Τρίτης Χώρας";}
case Domain.InvoiceType.Item24:
{
return "2.4 Τιμολόγιο Παροχής / Συμπληρωματικό Παραστατικό";}
case Domain.InvoiceType.Item31:
{
return "3.1 Τίτλος Κτήσης (μη υπόχρεος Εκδότης)";}
case Domain.InvoiceType.Item32:
{
return "3.2 Τίτλος Κτήσης (άρνηση έκδοσης από υπόχρεο Εκδότη)";}
case Domain.InvoiceType.Item51:
{
return "5.1 Πιστωτικό Τιμολόγιο / Συσχετιζόμενο";}
case Domain.InvoiceType.Item52:
{
return "5.2 Πιστωτικό Τιμολόγιο / Μη Συσχετιζόμενο";}
case Domain.InvoiceType.Item61:
{
return "6.1 Στοιχείο Αυτοπαράδοσης";}
case Domain.InvoiceType.Item62:
{
return "6.2 Στοιχείο Ιδιοχρησιμοποίησης";}
case Domain.InvoiceType.Item71:
{
return "7.1 Συμβόλαιο - Έσοδο";}
case Domain.InvoiceType.Item81:
{
return "8.1 Ενοίκια - Έσοδο";}
case Domain.InvoiceType.Item82:
{
return "8.2 Ειδικό Στοιχείο – Απόδειξης Είσπραξης Φόρου Διαμονής";}
case Domain.InvoiceType.Item84:
{
return "8.4 Απόδειξη Είσπραξης POS";}
case Domain.InvoiceType.Item85:
{
return "8.5 Απόδειξη Επιστροφής POS";}
case Domain.InvoiceType.Item86:
{
return "8.6 Δελτίο Παραγγελίας Εστίασης";}
case Domain.InvoiceType.Item93:
{
return "9.3 Παραστατικό Διακίνησης Μη Συσχετιζόμενο";}
case Domain.InvoiceType.Item111:
{
return "11.1 ΑΛΠ";}
case Domain.InvoiceType.Item112:
{
return "11.2 ΑΠΥ";}
case Domain.InvoiceType.Item113:
{
return "11.3 Απλοποιημένο Τιμολόγιο";}
case Domain.InvoiceType.Item114:
{
return "11.4 Πιστωτικό Στοιχ. Λιανικής";}
case Domain.InvoiceType.Item115:
{
return "11.5 Απόδειξη Λιανικής Πώλησης για Λογ/σμό Τρίτων";}
case Domain.InvoiceType.Item121:
{
return "12.1 Για Μελλοντική Χρήση";}
case Domain.InvoiceType.Item131:
{
return "13.1 Έξοδα - Αγορές Λιανικών Συναλλαγών ημεδαπής / αλλοδαπής";}
case Domain.InvoiceType.Item132:
{
return "13.2 Παροχή Λιανικών Συναλλαγών ημεδαπής / αλλοδαπής";}
case Domain.InvoiceType.Item133:
{
return "13.3 Κοινόχρηστα";}
case Domain.InvoiceType.Item134:
{
return "13.4 Συνδρομές";}
case Domain.InvoiceType.Item1330:
{
return "13.30 Παραστατικά Οντότητας ως Αναγράφονται από την ίδια (Δυναμικό)";}
case Domain.InvoiceType.Item1331:
{
return "13.31 Πιστωτικό Στοιχ. Λιανικής ημεδαπής / αλλοδαπής";}
case Domain.InvoiceType.Item141:
{
return "14.1 Τιμολόγιο / Ενδοκοινοτικές Αποκτήσεις";}
case Domain.InvoiceType.Item142:
{
return "14.2 Τιμολόγιο / Αποκτήσεις Τρίτων Χωρών";}
case Domain.InvoiceType.Item143:
{
return "14.3 Τιμολόγιο / Ενδοκοινοτική Λήψη Υπηρεσιών";}
case Domain.InvoiceType.Item144:
{
return "14.4 Τιμολόγιο / Λήψη Υπηρεσιών Τρίτων Χωρών";}
case Domain.InvoiceType.Item145:
{
return "14.5 ΕΦΚΑ και λοιποί Ασφαλιστικοί Οργανισμοί";}
case Domain.InvoiceType.Item1430:
{
return "14.30 Παραστατικά Οντότητας ως Αναγράφονται από την ίδια (Δυναμικό)";}
case Domain.InvoiceType.Item1431:
{
return "14.31 Πιστωτικό ημεδαπής / αλλοδαπής";}
case Domain.InvoiceType.Item151:
{
return "15.1 Συμβόλαιο - Έξοδο";}
case Domain.InvoiceType.Item161:
{
return "16.1 Ενοίκιο Έξοδο";}
case Domain.InvoiceType.Item171:
{
return "17.1 Μισθοδοσία";}
case Domain.InvoiceType.Item172:
{
return "17.2 Αποσβέσεις";}
case Domain.InvoiceType.Item173:
{
return "17.3 Λοιπές Εγγραφές Τακτοποίησης Εσόδων - Λογιστική Βάση";}
case Domain.InvoiceType.Item174:
{
return "17.4 Λοιπές Εγγραφές Τακτοποίησης Εσόδων - Φορολογική Βάση";}
case Domain.InvoiceType.Item175:
{
return "17.5 Λοιπές Εγγραφές Τακτοποίησης Εξόδων - Λογιστική Βάση";}
case Domain.InvoiceType.Item176:
{
return "17.6 Λοιπές Εγγραφές Τακτοποίησης Εξόδων - Φορολογική Βάση";}
default:
{
return "";}
}
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}